import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { IconName } from "../../types/icon-name";
import { IconSet } from "../../types/icon-set";

type IconCircleVariant = "primary" | "secondary" | "success" | "neutral";

@Component({
  selector: "icon-circle",
  templateUrl: "./icon-circle.component.html",
  styleUrls: ["./icon-circle.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCircleComponent {
  @Input() name: IconName;
  @Input() set: IconSet = "lucide";
  @Input() variant: IconCircleVariant = "secondary";
  @Input() size = 40;
  @Input() iconSize?: number;

  get resolvedIconSize(): number {
    return this.iconSize ?? Math.round(this.size / 2);
  }
}
